// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__gGsr0","error":"Message_error__0l2Zt","success":"Message_success___qaH1"};